export class ObjectHelper {

    public propertyValueExists(value: any): boolean {
        return value != null;
    }
}
